module.exports = __webpack_public_path__ + "static/media/parvaaz.c3aebeb4.png";